
import '../App.css';
import '../css/ImageGrid.css'

import { Tooltip } from "react-tooltip";
import { getuserDailylookList } from '../network/get_userDailylookList';
import React, { useState, useEffect,useRef, useCallback } from 'react';

import InfiniteScroll from 'react-infinite-scroll-component';

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 

import { useSearchParams, useNavigate } from 'react-router-dom';

import { MdArrowBackIos, MdOutlineIosShare } from "react-icons/md";


import { getUserProfile } from '../network/get_userprofile';

import { postFollow } from '../network/post_follow';
import { postUnfollow } from '../network/post_unfollow';
import { getRecommuser } from '../network/get_recommuser';
import { FaTimes } from 'react-icons/fa';

import { LoginRequiredModal } from '../components/loginpopup';
import { ProfileRequiredModal } from '../components/profilepopup';


import dayjs from 'dayjs';
// dayjs 플러그인 가져오기
import relativeTime from 'dayjs/plugin/relativeTime';
// 한국어 로케일(locale) 가져오기
import 'dayjs/locale/ko'; 

// 플러그인 사용 설정
dayjs.extend(relativeTime); 
// 언어를 한국어(ko)로 설정
dayjs.locale('ko'); 

const BASE_URL = 'http://52.79.160.172:8001';
const PAGE_SIZE = 10; // 한 번에 가져올 항목 수


// ... (기존 import 및 dayjs 설정)

function Profile_detail() {
    const [userProfile, setUser] = useState(null)
    // API 호출을 통해 받은 원본 응답 객체 (팔로워 수 등을 포함)
    const [profileData, setProfileData] = useState(null); 
    const [searchParams] = useSearchParams();
    const userId = searchParams.get('id');
       const [posts, setPosts] = useState([]);
         const [hasMore, setHasMore] = useState(true);
           const [isLoading, setIsLoading] = useState(false);
             const [pageKey, setPageKey] = useState(0);
                             const [isrecommview, setIsrecommview] = useState(false);
                                             const [recommUsers, setRecommUsers] = useState([]);


                                        const [showLoginModal, setShowLoginModal] = useState(false);
                                                const [showProfileModal, setShowProfileModal] = useState(false);
                                             
                                  

             const FALLBACK_IMAGE_URL = 'https://modii-media2.s3.ap-northeast-2.amazonaws.com/tempprofile.png';

                         const BADGE_IMAGE_MAP = {
                 '디렉터': 'https://modii-media2.s3.ap-northeast-2.amazonaws.com/director_badge.png',
                 '플래티넘': 'https://modii-media2.s3.ap-northeast-2.amazonaws.com/plat_badge.png',
                 '골드': 'https://modii-media2.s3.ap-northeast-2.amazonaws.com/gold_badge.png',
                 '실버': 'https://modii-media2.s3.ap-northeast-2.amazonaws.com/silver_badge.png',
                 // 뉴비는 여기에 포함하지 않음
             };


                 const toggleRecommUserFollow = async (userToToggle) => {
                     const action = userToToggle.is_followed ? postUnfollow : postFollow;
                    
                     try {
                         const updatedUser = await action(userToToggle.id);
                        
                         // recommsUsers 배열 업데이트: 해당 유저의 is_followed 상태를 토글
                         setRecommUsers(prevUsers => 
                             prevUsers.map(user => 
                                 user.id === updatedUser.id ? updatedUser : user
                             )
                         );
                     } catch (error) {
                         console.error("팔로우/언팔로우 실패:", error);
                     }
                 };
             
             const getBadgeImageSrc = (sense) => {
                 return BADGE_IMAGE_MAP[sense] || null; // 일치하는 것이 없으면 null 반환
             };

          
                 const navigate = useNavigate();
             
                 const handleImageError = (e) => {
                     console.log('error!')
                 // 이미 한 번 대체 이미지로 변경되었는데도 또 에러가 나면 무한 루프에 빠질 수 있으므로 방지
                 if (e.target.src !== FALLBACK_IMAGE_URL) {
                   e.target.src = FALLBACK_IMAGE_URL;
                 }
               };
               
    


      const goToPostDetail = (postId, postCategory) => {
    // 쿼리 파라미터 형태로 인자 구성: ?id=123&category=fashion
    const queryParams = new URLSearchParams({
      id: postId,
      category: postCategory
    }).toString();

    // /detail 경로로 인자를 포함하여 GET 방식으로 이동
    navigate(`/dailylook?${queryParams}`);
  };

    // 🚨 Critical fix: await를 사용하여 Promise의 결과를 기다려야 합니다.
    async function processData() {
        try {
            const userResponse = await getUserProfile(userId); // ⭐️ await 추가
            console.log("API 응답:", userResponse);
            console.log("API 응답:", userResponse.user);
            setProfileData(userResponse);
            setUser(userResponse.user); // 프로필 세부 정보만 user 상태에 저장
                      const recommuser = await getRecommuser(userResponse.user.id)
                      setRecommUsers(recommuser.results || []);
        } catch (error) {
            console.error("프로필 데이터 로드 실패:", error);
            // 사용자에게 오류 메시지를 표시하는 로직 추가 가능
        }
    }

    const fetchPosts = useCallback(async () => {
      console.log(userId)
        // 주의: 함수 내부에서 최신 posts.length를 사용하지 않으므로 posts는 의존성에서 제외
        if (isLoading || !hasMore) return; // 중복 요청 방지
    
        setIsLoading(true);
        
        try {
          const response = await getuserDailylookList(
            pageKey, // 최신 pageKey 사용
            PAGE_SIZE,
            userId
          );
          
          const newPosts = response.results || [];
          const totalCount = response.count;
    
          // 이전 상태를 기반으로 업데이트해야 정확함
          setPosts(prevPosts => {
              const updatedPosts = [...prevPosts, ...newPosts];
              
              // *주의: posts.length 대신 updatedPosts.length를 사용해야 정확함*
              if (updatedPosts.length >= totalCount) {
                  setHasMore(false);
              }
              return updatedPosts;
          });
          
          setPageKey(prevKey => prevKey + PAGE_SIZE); // 함수형 업데이트를 사용하여 최신 pageKey 보장
          
        } catch (error) {
          console.error("데이터 로딩 실패:", error);
          setHasMore(false);
        } finally {
          setIsLoading(false);
        }
    }, [pageKey, hasMore, isLoading]);

    useEffect(() => {
        if (userId) {
            processData();
        }
    }, [userId]);

    const goBack = () => {
        navigate(-1);
    };

        useEffect(() => {
        if (pageKey === 0 && hasMore) {
            fetchPosts();
        }
      }, []);
    
    // profileData가 없으면 로딩 중 상태 표시
    if (!profileData) {
        return <div style={{

          display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '250px',
    }}>


      <span style={{    marginBottom: '30px',
    fontSize: '12pt'}}>불러오는 중..</span>

      <img
                              src={'loading_logo.jpg'}

                              style={{
                                width: '50px',
                                marginRight: '10px'
                                // height: '44px',
                                // borderRadius: '50%',
                                // objectFit: 'cover',
                                // marginRight: '12px',
                              }}
                            />
      

      
      </div>;
    }

    const follow = async () => {
           
           if(userProfile.is_followed){
            
            const _user = await postUnfollow(userProfile.id)
           setUser(_user)
           setIsrecommview(false)
           }else{
       const _user = await postFollow(userProfile.id)
       if(_user == 'PROFILE_NOT_FILLED'){
          setShowProfileModal(true)
       }else{
       setUser(_user)
       setIsrecommview(true)
       }
           }
        };
    
    // API 응답에서 필요한 데이터 추출
    // const { followers, dailylook_count, username } = profileData;
    // const { thumbnail, height, body_type, fashion_sense, average_score, instagram_username } = profileData.profile;
    
    // Fashion sense 표시 문자열 조합 (예: "티어 ⓘ 플래티넘 3.93")
    const tierDisplay = `${profileData.user.profile.fashion_sense} ${profileData.user.profile.average_score}`;

        const fashionSense = profileData.user.profile.fashion_sense;
const badgeSrc = getBadgeImageSrc(fashionSense);
const isNewbie = fashionSense === '뉴비';

             const imageStyle = {
    marginTop: '10px',
    height: '40px',
    display: 'block',
    // ⭐️ 뉴비일 때만 이미지를 숨기고 공간은 유지
    visibility: isNewbie ? 'hidden' : 'visible', 
};
      
    return (
        <div style={styles.mobileContainer}>
            {/* 1. 헤더 영역 (고정 상단바) */}

                                                <LoginRequiredModal
                                            isOpen={showLoginModal}
                                            onClose={() => setShowLoginModal(false)}
                                          />
            
                                          <ProfileRequiredModal
                                            isOpen={showProfileModal}
                                            onClose={() => setShowProfileModal(false)}
                                          />

            <header style={styles.header}>
                <div style={styles.headerContent}>
                    <div style={styles.headerLeft}>
                        <MdArrowBackIos size="24" onClick={goBack} style={styles.iconStyle} />
                    </div>
                    <span style={styles.usernameHeader}>{profileData.user.username}</span>
                    <button style={styles.optionsButton}>
                        {/* <div style={styles.dot}></div>
                        <div style={styles.dot}></div>
                        <div style={styles.dot}></div> */}
                    </button>
                </div>
                <div style={styles.divider} />
            </header>

            {/* 2. 본문 (스크롤 영역) */}
            <main style={styles.mainContent}>

                {/* 3. 프로필 상단 영역 */}
                <div style={styles.profileHeader}>
                    
                    {/* 프로필 사진 및 닉네임 */}
                    <div style={styles.profileInfoRow}>
                        {/* 원형 이미지 */}
                        <div style={styles.imageWrapper}>
                            <img src={profileData.user.profile.thumbnail ? profileData.user.profile.thumbnail : "https://modii-media2.s3.ap-northeast-2.amazonaws.com/tempprofile.png"} alt="프로필 사진" style={styles.profileImage} />
                        </div>
                        
                        <div style={styles.textGroup}>
                            <h1 style={styles.username}>{profileData.user.username}</h1>
                            
                            {/* 티어 및 평균 점수 */}
                            <p style={styles.tierText}>
                                <span style={styles.tierLabel}>티어 ⓘ</span>
                                <span style={styles.tierValue}>{tierDisplay}</span>
                            </p>
                        </div>
                    </div>

                    {/* 키, 체형, 인스타그램 정보 */}
                    <div style={styles.detailsRow}>
                        <div style={styles.detailItem}>
                            <span style={styles.detailIcon}>👤</span>
                            <span style={styles.detailText}>{profileData.user.profile.height}cm · {profileData.user.profile.body_type}</span>
                        </div>
                        <div style={styles.detailItem}>
                            <span style={styles.detailIcon}>📷</span>
                            <span style={styles.detailText}>@{profileData.user.profile.instagram_username}</span>
                        </div>
                    </div>

                    <div style={styles.tierAndBadgesRow}>


                            {/* 뱃지들 (new_title 배열) */}
                            <div style={styles.badgesContainer}>

                                   
                                        <div 
                                        style={{
                                            display: 'flex',          // ⭐️ Flexbox 사용
                                            flexDirection: 'column',  // ⭐️ 아이템들을 수직으로 정렬 (이미지 위에 뱃지 텍스트)
                                            alignItems: 'center',     // ⭐️ 주 축(세로)에 대해 교차 축(가로) 중앙 정렬
                                            justifyContent: 'center', // ⭐️ 주 축(세로) 중앙 정렬 (필요시)
                                            gap: '5px'                // ⭐️ 이미지와 뱃지 텍스트 사이의 간격
                                        }}
                                    >
                                        <img 
                src={badgeSrc || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'} 
                alt={`${fashionSense} 뱃지`}
                // ⭐️ 이미지 소스가 있을 때만 표시, 없으면 투명 GIF나 빈 이미지 사용
                style={imageStyle} 
            />
                                        <div
                                            
                                            style={{
                                                ...styles.badge, // 기존 뱃지 스타일 유지
                                                backgroundColor: '#ecececff',
                                                color: '#b6b6b6ff',
                                                borderColor:  '#FFFFFF',
                                                //fontWeight:  'bold',
                                                // 뱃지 텍스트도 Flex item이므로 추가적인 정렬 스타일 불필요
                                                textAlign: 'center' // 뱃지 텍스트 자체의 정렬 (내부 텍스트)
                                            }}
                                        >
                                            {profileData.user.profile.fashion_sense}
                                        </div>
                                         </div>



                                {profileData.user.profile.new_title?.map((badge, index) => (
                                    
                                    <div 
                                        style={{
                                            display: 'flex',          // ⭐️ Flexbox 사용
                                            flexDirection: 'column',  // ⭐️ 아이템들을 수직으로 정렬 (이미지 위에 뱃지 텍스트)
                                            alignItems: 'center',     // ⭐️ 주 축(세로)에 대해 교차 축(가로) 중앙 정렬
                                            justifyContent: 'center', // ⭐️ 주 축(세로) 중앙 정렬 (필요시)
                                            gap: '5px'                // ⭐️ 이미지와 뱃지 텍스트 사이의 간격
                                        }}
                                    >
                                        <img 
                                            src= {badge.name == '주간 모디' ? 
                                            
                                            'https://modii-media2.s3.ap-northeast-2.amazonaws.com/weekly_dailylook_badge.png' :
                                            badge.name == '월간 모디' ? 

                                            'https://modii-media2.s3.ap-northeast-2.amazonaws.com/months_dailylook_badge.png':
                                            ''
                                            }
                                            style={{
                                                marginTop : badge.name == '주간 모디' ? '10px' : '0px',
                                                height:  badge.name == '주간 모디' ? '40px' : '50px',
                                                // 이미지가 Flex item이므로 추가적인 margin: 'auto'는 필요하지 않습니다.
                                                // 하지만 너비를 'auto'로 설정하여 부모에 맞출 수도 있습니다.
                                                // width: 'auto', 
                                                // maxWidth: '100%', // 반응형을 위해 추가
                                                display: 'block' // 이미지를 블록 레벨 요소로 만들어 불필요한 공백 제거
                                            }}
                                        />
                                        {badge.name == '주간 모디' || badge.name == '월간 모디' ? 
                                        <div
                                            key={index}
                                            style={{
                                                ...styles.badge, // 기존 뱃지 스타일 유지
                                                backgroundColor: badge.background_color || '#FFEDC8',
                                                color: badge.text_color || '#FFBB31',
                                                borderColor: badge.border_color || '#FFFFFF',
                                                fontWeight: badge.is_bold_text ? 'bold' : 'normal',
                                                // 뱃지 텍스트도 Flex item이므로 추가적인 정렬 스타일 불필요
                                                textAlign: 'center' // 뱃지 텍스트 자체의 정렬 (내부 텍스트)
                                            }}
                                        >
                                            {badge.name}
                                        </div> : 
                                            <></>
                                            }
                                    </div>
                                ))}
                            </div>
                        </div>
                </div>

                {/* 4. 팔로우/게시물 카운트 및 팔로우 버튼 */}
                <div style={styles.statsContainer}>
                    {/* 카운트 박스 */}
                    <div style={styles.statsBox}>
                        <div style={styles.statItem}>
                            <div style={styles.statCount}>{profileData.user.followers}</div>
                            <div style={styles.statLabel}>팔로워</div>
                        </div>
                        <div style={styles.statDivider}></div>
                        <div style={styles.statItem}>
                            <div style={styles.statCount}>{profileData.user.dailylook_count}</div>
                            <div style={styles.statLabel}>게시물</div>
                        </div>
                    </div>
                    
                    {/* 팔로우 버튼 */}
                    <button 
            style={{
                backgroundColor: userProfile.is_followed ? '#f2f2f2' :'#e74c3c', // 사진 속 빨간색
                color: userProfile.is_followed ? '#cacacaff' :'#ffffffff',
                border: 'none',
                borderRadius: '8px', // 둥근 모서리
                padding: '8px 15px',
                fontWeight: 'bold',
                cursor: 'pointer',
                fontSize: '14px',
                width:'100%'
            }}
             onClick={() =>{ 
                
                              const savedToken = localStorage.getItem('user');
            const storedUserObject = JSON.parse(savedToken);
            if(storedUserObject.username == 'temp'){
                        setShowLoginModal(true);

            }else if(storedUserObject.username != userProfile.username){
                                follow()
            }

             }}
        >
            {userProfile.is_followed ? "팔로잉" : "팔로우"}
        </button>
                </div>
                       {isrecommview && (
                                          <div style={styles.recommFollowContainer}>
                                            <div style={styles.headerRow}>
                                              <h3 style={styles.recommTitle}>팔로우 추천</h3>
                                              <FaTimes size={20} color="#333" onClick={() => {setIsrecommview(false)}} />
                                              </div>
                                              <div style={styles.recommList}>
                                                  {recommUsers.slice(0, 4).map((user) => (
                                                      <FollowUserCard 
                                                          key={user.id} 
                                                          user={user} 
                                                          onToggle={toggleRecommUserFollow} 
                                                      />
                                                  ))}
                                              </div>
                                             
                                          </div>
                                      )}
                                      <div style={styles.statCount}>데일리룩</div>

                {/* 5. 콘텐츠 그리드 영역 (임시) */}
                <div style={styles.contentGrid}>
                    <InfiniteScroll
                                  dataLength={posts.length} // 현재 로드된 항목 수
                                  next={fetchPosts}         // 스크롤이 끝에 도달하면 호출할 함수
                                  hasMore={hasMore}  
                                  scrollThreshold="60%"        // 더 불러올 데이터가 있는지 여부
                                  loader={<h4 style={{ textAlign: 'center' }}>로딩 중...</h4>}
                                  endMessage={<p style={{ textAlign: 'center' }}><b>모든 결과를 불러왔습니다.</b></p>}
                                  //scrollableTarget="scrollableDiv" // 스크롤바가 있는 DOM 요소의 ID (없다면 window)
                                >
                                  <div style={styles.postsGrid}>
                    
                                    {posts.map((post, index) => (
                                      <div key={index} style={styles.postItem}>
                    
                                        <img src={post.thumbnail} alt={post.keyword} style={styles.postImage}
                                                    onClick={() => goToPostDetail(post.id, 'd')}
                                        
                                        />
                                        {post.more_images.length > 1?
                                            <img src="/more.png" style={{ width: '25px', verticalAlign: 'middle',position:'absolute',top:"5px",right:'5px' }}/> : <></>
                                            }
                                        <p>{post.description}</p>
                                      </div>
                                    ))}
                                  </div>
                                </InfiniteScroll>
                </div>

            </main>
        </div>
    );
}

  function FollowUserCard({ user, onToggle }) {
    const isFollowed = user.is_followed;
    const thumbnail = user.profile?.thumbnail || "https://www.studiopeople.kr/common/img/default_profile.png";
    return (
        <div style={cardStyles.recommCard}>
            <img src={thumbnail} alt={user.username} style={cardStyles.recommImage} />
            <span style={cardStyles.recommUsername}>{user.username}</span>
            <button 
                onClick={() => onToggle(user)}
                style={isFollowed ? cardStyles.followingButton : cardStyles.followButton}
            >
                {isFollowed ? '팔로잉' : '팔로우'}
            </button>
        </div>
    );
}

const cardStyles = {
    // ... (기존 cardStyles 유지) ...
    
    // ⭐️ 추천 유저 카드 스타일
    recommCard: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        flexShrink: 0, // 카드가 줄어들지 않도록
        width: '80px', // 카드 너비 고정
    },
    recommImage: {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        objectFit: 'cover',
        marginBottom: '5px',
    },
    recommUsername: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: '#333',
        marginBottom: '5px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
    },
    followButton: {
        backgroundColor: '#e74c3c', // 빨간색
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: '5px',
        fontSize: '11px',
        cursor: 'pointer',
    },
    followingButton: {
        backgroundColor: '#b7b7b7', // 회색
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: '5px',
        fontSize: '11px',
        cursor: 'pointer',
    },
};

// ----------------------------------------------------
// 스타일 정의 (모바일에 맞춤)
// ----------------------------------------------------

const styles = {

      recommFollowContainer: {
        padding: '0 1vw',
        
        position: 'relative', // X 버튼 등의 배치를 위해
    },
    recommTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
        margin: '0 0 10px 0',
    },
    recommList: {
        display: 'flex',
        //overflowX: 'scroll', // ⭐️ 가로 스크롤 가능
        gap: '15px',
        paddingBottom: '10px',
        // 스크롤바 숨김 처리 필요 (App.css 또는 전역 스타일에서)
    },
    recommDivider: {
        height: '1px',
        backgroundColor: '#eee',
        margin: '15px 0',
    },

      tierAndBadgesRow: {
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: '8px',
    margin: '5px 0 0 0',
},

tierText: {
    fontSize: '14px',
    color: '#333',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '6px',
},

tierLabel: {
    color: '#777',
    marginRight: '5px',
},

tierValue: {
    color: '#ff4d4f',
    fontWeight: 'bold',
},

tierPercentage: {
    color: '#888',
    fontSize: '12px',
    marginLeft: '8px',
},

badgesContainer: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',        // 길면 자동 줄바꿈
    marginTop: '4px',
},

badge: {
    padding: '4px 10px',
    borderRadius: '20px',
    fontSize: '12px',
    border: '2px solid',
    display: 'inline-block',
    whiteSpace: 'nowrap',
    lineHeight: '1.4',
},

    // ----------------- 레이아웃 기본 -----------------
    mobileContainer: {
        maxWidth: '420px', 
        margin: '0 15px', 
        minHeight: '100vh',
    },
    loadingContainer: {
        textAlign: 'center',
        paddingTop: '100px',
        fontSize: '18px',
    },

        postsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr', 
        gap: '1px',
    },
    postItem: {
        overflow: 'hidden',
        height: '160px',
        cursor:'pointer',
        position:'relative'
    },
    postImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    
    // ----------------- 헤더 (고정) -----------------
    header: {
        position:'fixed',
        top:'0',
        width:'100%',
        maxWidth:'420px',
        backgroundColor:'white',
        zIndex:'10',
        paddingTop: '20px',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    },
    headerContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 15px', 
    },
    headerLeft: {
        width: '30px',
    },
    usernameHeader: {
        fontSize: '18px',
        fontWeight: 'bold',
        flexGrow: 1,
        textAlign: 'center',
    },
    optionsButton: {
        width: '30px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        height: '24px',
    },
    dot: {
        width: '4px',
        height: '4px',
        backgroundColor: '#333',
        borderRadius: '50%',
        margin: '1px 0',
    },
    divider: {
        height: '1px', 
        backgroundColor: '#d4d4d4ff', 
        marginTop: '10px', 
    },

    // ----------------- 본문 및 프로필 -----------------
    mainContent: {
        // 고정 헤더 높이만큼 패딩 추가 (대략 60px)
        padding: '65px 1vw 0 1vw',
    },
    profileHeader: {
        marginBottom: '20px',
        paddingTop: '20px',
    },
    profileInfoRow: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '15px',
    },
    imageWrapper: {
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        overflow: 'hidden',
        marginRight: '15px',
        flexShrink: 0,
    },
    profileImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    textGroup: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    username: {
        fontSize: '22px',
        fontWeight: 'bold',
        margin: '0',
    },
    tierText: {
        fontSize: '14px',
        color: '#333',
        margin: '5px 0 0 0',
    },
    tierLabel: {
        color: '#777',
        marginRight: '5px',
    },
    tierValue: {
        color: '#ff4d4f', // 이미지의 붉은색
        fontWeight: 'bold',
    },
    detailsRow: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        color: '#555',
        fontSize: '15px',
        marginBottom: '20px',
    },
    detailItem: {
        display: 'flex',
        alignItems: 'center',
    },
    detailIcon: {
        marginRight: '8px',
    },
    detailText: {
        //
    },

    // ----------------- 통계 및 버튼 -----------------
    statsContainer: {
        marginBottom: '30px',
    },
    statsBox: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        backgroundColor: '#f8f8f8',
        borderRadius: '10px',
        padding: '15px 0',
        marginBottom: '20px',
    },
    statItem: {
        textAlign: 'center',
        flex: 1,
    },
    statCount: {
        fontSize: '20px',
        fontWeight: 'bold',
    },
    statLabel: {
        fontSize: '12px',
        color: '#666',
    },
    statDivider: {
        width: '1px',
        height: '30px',
        backgroundColor: '#e0e0e0',
    },
    followButton: {
        width: '100%',
        padding: '15px 0',
        backgroundColor: '#ff4d4f', // 이미지의 빨간색
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        fontSize: '18px',
        fontWeight: 'bold',
        cursor: 'pointer',
    },

    // ----------------- 그리드 -----------------
    contentGrid: {
        //borderTop: '1px solid #ddd',
        paddingTop: '20px',
        textAlign: 'center',
    }
};

export default Profile_detail;